import withDatas from '../withDatas'

import defaultStyles from './styles'

const withMap = withDatas( defaultStyles ) ;

export default withMap ;
